/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_INTERFACE_LIST,
  FETCH_INTERFACE_LIST_SUCCESS,
  FETCH_INTERFACE_LIST_FAILURE,
  FETCH_METRIC_LIST,
  FETCH_METRIC_LIST_SUCCESS,
  FETCH_METRIC_LIST_FAILURE,
  FETCH_INTERFACE_LIST_ADD_SUCCESS,
  FETCH_INTERFACE_LIST_ADD_FAILURE,
  CHANGE_INTERFACES_COUNT,
} from "./actionTypes";
import { Interfaces as interfaceAPI } from "./interfaces";
import * as IntegrationError from "./../../components/settings/integrations/IntegrationError";

function getResponseError(error) {
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data;
  } else {
    return IntegrationError.getDefaultError();
  }
}

export function fetchInterfacesList() {
  return {
    type: FETCH_INTERFACE_LIST,
  };
}

export function fetchInterfacesSuccess(json) {
  return {
    type: FETCH_INTERFACE_LIST_SUCCESS,
    data: json,
  };
}

export function fetchInterfacesFailure(error) {
  return {
    type: FETCH_INTERFACE_LIST_FAILURE,
    errorMessage: error.message,
  };
}
export function fetchInterfacesAddSuccess(json) {
  return {
    type: FETCH_INTERFACE_LIST_ADD_SUCCESS,
    data: json,
  };
}

export function fetchInterfacesAddFailure(error) {
  return {
    type: FETCH_INTERFACE_LIST_ADD_FAILURE,
    errorMessage: error.message,
  };
}
export function fetchMetricData() {
  return {
    type: FETCH_METRIC_LIST,
  };
}

export function fetchMetricSuccess(json) {
  return {
    type: FETCH_METRIC_LIST_SUCCESS,
    data: json,
  };
}

export function fetchMetricFailure(error) {
  return {
    type: FETCH_METRIC_LIST_FAILURE,
    errorMessage: error.message,
  };
}

export function changeInterfacesCount(count) {
  return {
    type: CHANGE_INTERFACES_COUNT,
    interfacesCount: count
  }
}

export function fetchInterfaces(params) {
  return (dispatch) => {
    dispatch(fetchInterfacesList());
    return interfaceAPI
      .getRegularFields(params)
      .then((response) => response.data)
      .then((json) => dispatch(fetchInterfacesSuccess(json)))
      .catch(function (error) {
        dispatch(fetchInterfacesFailure(getResponseError(error)));
      });
  };
}

export function fetchInterfacesToAdd(params) {
  return (dispatch) => {
    dispatch(fetchInterfacesList());
    return interfaceAPI
      .getMasterElements(params)
      .then((response) => response.data)
      .then((json) => dispatch(fetchInterfacesAddSuccess(json)))
      .catch(function (error) {
        dispatch(fetchInterfacesAddFailure(getResponseError(error)));
      });
  };
}

export function fetchMetrics(params) {
  return (dispatch) => {
    dispatch(fetchMetricData());
    return interfaceAPI
      .getMetricFields(params)
      .then((response) => response.data)
      .then((json) => dispatch(fetchMetricSuccess(json)))
      .catch(function (error) {
        dispatch(fetchMetricFailure()(getResponseError(error)));
      });
  };
}
